<template>
  <module-configuration :data="config" :errors="errors">
    <div slot="auth" class="l-row">
      <form-group label="Ambiente" :required="true">
        <select v-model="config.auth.environment" class="form-select">
          <option value="sandbox">Sandbox</option>
          <option value="production">Produção</option>
        </select>
      </form-group>
      <form-group label="Shop ID">
        <input class="form-input" v-model="config.auth.shopId">
      </form-group>
      <form-group label="Chave">
        <input class="form-input" v-model="config.auth.apiKey">
      </form-group>
    </div>

    <panel title="Produtos">
      <div class="l-row">
        <product-price-configuration :input="config.product.price"/>
        <form-group label="Redutor de estoque padrão">
          <input class="form-input" min="0" type="number" v-model="config.product.stock.reducer">
        </form-group>
      </div>
    </panel>

    <panel :title="$t('order.label')">
      <form-group label="Utilizar endereço de entrega como de cobrança">
        <label class="form-switch">
          <input type="checkbox" v-model="config.order.shippingAddressAsBillingAddress">
          <span class="form-switch__indicator"></span>
        </label>
        <small class="form-help">Define se o endereço de entrega será utilizado como endereço de cobrança.</small>
      </form-group>
    </panel>

    <panel :title="$t('expediter.label')">
      <expediter-configuration :expediter="config.order.expediter"/>
    </panel>

    <panel :title="$t('quotation.label')">
      <div class="l-row">
        <form-group label="Transportadora para cotação do frete">
          <select v-model="config.quotation.shipmentMethod" class="form-select">
            <option :value=null>{{ $t('choose.label') }}</option>
            <option :value="module.identifier" v-for="module in definitionShipmentsInstalled">{{ $t(`${module.identifier}.label`) }}</option>
          </select>
        </form-group>

        <form-group label="URL">
          {{ urlQuotation }}

          <button type="button" @click="copied()" class="btn btn--sm btn--info copy hint hint--top" data-label="Clique para copiar token" v-clipboard:copy="urlQuotation">
            <i class="icon icon-copy2"></i>
          </button>
        </form-group>
      </div>
    </panel>

    <panel :title="$t('order.label')">
      <order-retrieve-date-configuration :orderConfigs="config.order"/>
    </panel>

    <panel title="Sincronização">
      <div class="l-row">

        <form-group label="Sincronizar estoque" :columns="3">
          <select class="form-select" v-model="config.synchronize.stock">
            <option v-for="option in synchronizeOptions" :key="option" :value="option">{{$t(`${option}.label`) }}</option>
          </select>
          <small class="form-help">Define se os estoques serão sincronizados e atualizados no Carrefour.</small>
        </form-group>

        <form-group label="Sincronizar preço" :columns="3">
          <select class="form-select" v-model="config.synchronize.price">
            <option v-for="option in synchronizeOptions" :key="option" :value="option">{{$t(`${option}.label`) }}</option>
          </select>
          <small class="form-help">Define se os preços serão sincronizados e atualizados no Carrefour.</small>
        </form-group>

      </div>
    </panel>

  </module-configuration>
</template>

<script>
  import { mapGetters } from 'vuex'
  import ModuleConfiguration from '@/views/Configuration/Shared'
  import FormGroup from '@/components/template/FormGroup'
  import Panel from '@/components/template/Panel'
  import Loader from '@/components/template/Loader'
  import ProductPriceConfiguration from '@/components/shared/ProductPriceConfiguration'
  import ExpediterConfiguration from '@/components/marketplace/shared/ExpediterConfiguration'
  import cookie from 'vue-cookie'
  import OrderRetrieveDateConfiguration from '@/components/marketplace/shared/OrderRetrieveDateConfiguration'

  export default {
    inject: ['expeditersDI', 'priceTypeDI'],
    provide: {
      moduleDI: {
        type: 'marketplace',
        identifier: 'carrefour'
      }
    },
    data: () => ({
      errors: [],
      type: 'marketplace',
      identifier: 'carrefour',
      config: {
        auth: {
          environment: 'sandbox',
          shopId: null,
          apiKey: null
        },
        product: {
          price: {
            type: null,
            percent: null
          },
          stock: {
            reducer: 0
          }
        },
        order: {
          expediter: {
            type: null,
            identifier: null
          },
          retrieveDate: null,
          shippingAddressAsBillingAddress: false
        },
        quotation: {
          shipmentMethod: null
        },
        synchronize: {
          stock: true,
          price: true
        }
      },
      synchronizeOptions: [
        true,
        false
      ]
    }),
    watch: {
      'config.product.stock.reducer' (value) {
        this.config.product.stock.reducer = parseInt(value)
      }
    },
    computed: {
      ...mapGetters('module', [
        'definitionEcommerceInstalled',
        'definitionShipmentsInstalled'
      ]),
      urlQuotation () {
        let url = `https://quotation.placemarket.com.br/carrefour/${cookie.get('merchant')}`

        if (window.location.hostname === 'localhost') {
          url = `http://localhost:4000/carrefour/${cookie.get('merchant')}`
        }

        return url
      }
    },
    components: {
      OrderRetrieveDateConfiguration,
      FormGroup,
      ModuleConfiguration,
      Panel,
      Loader,
      ProductPriceConfiguration,
      ExpediterConfiguration
    }
  }
</script>



// WEBPACK FOOTER //
// Carrefour.vue?31f46c96